import { createContext, useContext } from "react";

const UploadContext = createContext({});

export const UploadContextProvider = UploadContext.Provider;
export const UploadContextConsumer = UploadContext.Consumer;

export const useUploadContext = () => useContext(UploadContext);

export default UploadContext;
